"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isUrlKeyHasValue = void 0;
var isUrlKeyHasValue = function isUrlKeyHasValue(location, key, value) {
  var params = new URLSearchParams(location.search);
  if (!params) {
    return false;
  }
  var keyValue = params.get(key);
  if (!keyValue) {
    return false;
  }
  if (keyValue === value) {
    return true;
  }
  return false;
};
exports.isUrlKeyHasValue = isUrlKeyHasValue;